import { isToday, isValid } from 'date-fns'
import { DateFormat } from '@/enums/DateFormat'
import i18n from '@/i18n/i18n'

function formatVitalDate(date: string): string | null {
  let formattedDate = null

  if (isValid(new Date(date))) {
    if (isToday(date)) {
      formattedDate = i18n.global.d(new Date(date), DateFormat.TIME)
    } else {
      formattedDate = i18n.global.d(new Date(date), DateFormat.DATE_TIME)
    }
  }

  return formattedDate
}

export function getVitalDateLabel(date: string): string {
  let displayValue = formatVitalDate(date)

  if (!displayValue) {
    displayValue = i18n.global.t('No current data available')
  } else if (i18n.global.locale.value === 'de') {
    displayValue = displayValue += ' Uhr'
  }

  return displayValue
}
